import { useEffect, useState } from "react";
import "../styles/CamerFed.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BsGrid3X2, BsThreeDotsVertical } from "react-icons/bs";
import { DeleteCameraGroupApi, fetchCameragrouplistingApi } from "../api/api";
import cameraimg from "../assets/image 285.png";
import Dropdown from "react-bootstrap/Dropdown";
import { MdCheckBoxOutlineBlank, MdOutlineGridOn } from "react-icons/md";
import { LuGrid2X2 } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { IoSettingsSharp } from "react-icons/io5";
import { SetGroupData } from "../store/reducer/livefeed";
import { useCamera } from "../context/CameraProvider";
import { useVisionContext } from "../Components/ContextAPI/VisionContext";

// import Placeholder from "assets/image 285.png";

const VideoWall = () => {
  const [grid, setGrid] = useState(4);
  const [createWall, setCreateWall] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { videoWall } = useVisionContext();

  const navigate = useNavigate();

  //   const toggleWallButton = () => {
  //     setCreateWall(!createWall);
  //   };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  //   const [pagination, setPagination] = useState({
  //     pageIndex: 0,
  //     pageSize: 12,
  //   });
  //   const [showAllCameras, setShowAllCameras] = useState(true);

  //   const [totalRows, setTotalRows] = useState(0);

  const [gridDisplay, setGridDisplay] = useState({
    icon: <LuGrid2X2 size={24} />,
    label: "2x2",
  });

  //   useEffect(() => {
  //     if (camera.length > 0) {
  //       const cams = camera.map((cam) => ({
  //         id: cam._id,
  //         name: cam.camera_name,
  //         camera_url: cam.camera_url || cameraimg,
  //       }));
  //       setActiveFeeds(cams);
  //       setGrid(getBestGrid(cams.length));
  //     }
  //   }, [camera]);

  //   const getBestGrid = (count) => {
  //     if (count <= 1) return 1;
  //     if (count <= 4) return 4;
  //     if (count <= 6) return 6;
  //     if (count <= 9) return 9;
  //     return 12;
  //   };

  const getGridClass = () => {
    if (grid === 1) return "grid-1";
    if (grid === 4) return "grid-4";
    if (grid === 6) return "grid-6";
    if (grid === 9) return "grid-9";
    return "grid-12";
  };

  //   const handleClose = () => setShow(false);

  //   const handleGroupSubmit = (e) => {
  //     e.preventDefault();
  //     if (groupName.trim()) {
  //       const formData = new FormData();
  //       formData.append("groupName", groupName);
  //       if (groupImage) formData.append("groupImage", groupImage);

  //       dispatch(
  //         SetGroupData({
  //           groupName,
  //           groupImage,
  //         })
  //       );
  //       handleClose();
  //       navigate(`/create-camera-group`);
  //     }
  //   };

  //   const handleRightClick = (event, camera) => {
  //     event.preventDefault();
  //     setSelectedCamera(camera);
  //     setContextMenu({
  //       x: event.pageX,
  //       y: event.pageY,
  //     });
  //   };

  //   const handleDelete = async (id) => {
  //     try {
  //       const data = await DeleteCameraGroupApi(id);

  //       if (data) {
  //         fetchGroup();
  //       }
  //     } catch (error) {}
  //   };

  //   const tooglePlay = (e, id) => {
  //     e.preventDefault();
  //     if (cameras.includes(id)) setCameras((prev) => prev.filter((ele) => ele !== id));
  //     else setCameras((prev) => [...prev, id]);
  //   };

  const handleCameraFeed = (id) => {
    // setCameras([id]);

    navigate(`/events-details?id=${id}`);
  };

  return (
    <>
      <div className="d-flex">
        {/* Grid Section */}
        <div className="leftSection">
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              {/* <h4 className="m-0">Video Wall</h4> */}
              <div class="live-indicator">
                <div class="dot"></div>
                LIVE
              </div>

              <div className="selectCameraGrid align-items-center gap-3">
                {/* <button className="selectBtn" onClick={toggleWallButton}>
                  Select
                </button> */}
                <div className="singleBox m-0">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      {gridDisplay.icon}
                      {/* {gridDisplay.label} */}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          setGrid(1);
                          setGridDisplay({
                            icon: <MdCheckBoxOutlineBlank size={24} />,
                            label: "1x1",
                          });
                        }}
                      >
                        <MdCheckBoxOutlineBlank size={24} /> 1x1
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setGrid(4);
                          setGridDisplay({
                            icon: <LuGrid2X2 size={24} />,
                            label: "2x2",
                          });
                        }}
                      >
                        <LuGrid2X2 size={24} /> 2x2
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setGrid(6);
                          setGridDisplay({
                            icon: <BsGrid3X2 size={24} />,
                            label: "2x3",
                          });
                        }}
                      >
                        <BsGrid3X2 size={24} /> 2x3
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setGrid(9);
                          setGridDisplay({
                            icon: <MdOutlineGridOn size={24} />,
                            label: "3x3",
                          });
                        }}
                      >
                        <MdOutlineGridOn size={24} /> 3x3
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div className={`camera-grid ${getGridClass()}`}>
              {(grid === 1 ? videoWall.slice(0, grid) : videoWall).map((cam) => (
                <div key={cam?.id} className={`camera-tile`}>
                  <img
                    src={`https://visionemptrack.greymatterz.com/stream2/stream2/${
                      cam?.id
                    }?t=${Date.now()}`}
                    onClick={() => handleCameraFeed(cam?.id)}
                    alt={cam?.name}
                  />
                  <div className="camera-label">{cam?.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoWall;
